import { createApp } from "vue";
import store from "./store/index";
import App from "./App.vue";
import { WOW } from "wowjs";
import "animate.css"; // 引入animate.css
import router from "./router/index";
import ImageComponent from "@/views/webViews/components/imageComponent.vue";
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
import ArcoVue from "@arco-design/web-vue";
import videojs from "video.js"; // 引入video.js
window.$video = videojs; // 将video.js挂载到window上
import "video.js/dist/video-js.css";
// 额外引入图标库
import ArcoVueIcon from "@arco-design/web-vue/es/icon";
import "@arco-design/web-vue/dist/arco.css";

const app = createApp(App);

app.component("ImageComponent", ImageComponent);

app.config.globalProperties.$video = videojs;
window.$wow = new WOW({
  boxClass: "wow", // 类名，在用户滚动时显示隐藏的框。
  animateClass: "animate__animated", // 触发CSS动画的类名称
  offset: 0, // 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并到达此距离时，隐藏的框会显示出来。
  mobile: false, // 在移动设备上打开/关闭WOW.js。
  reset: false, // 当用户滚动到隐藏框时，是否重置其动画。
  live: true, // 在页面上同时检查新的WOW元素。
});
app.use(store).use(router).use(ArcoVue).use(ArcoVueIcon).mount("#app");
